import { Component, Input, OnInit } from '@angular/core';
import { ServiceTypeService } from '../../../../../services/service-type.service';
import { PartnerService } from '../../../../../services/partner.service';
import { AppConfig } from '../../../../../app.config';

@Component({
  selector: 'app-service-type-message-templates',
  templateUrl: './service-type-message-templates.component.html',
  styleUrls: ['./service-type-message-templates.component.scss'],
})
export class ServiceTypeMessageTemplatesComponent implements OnInit {
  @Input() serviceType;
  @Input() partner;

  public messageTemplates: any = [];
  public loading: boolean = false;
  public selectedMessageTemplate: any = {};
  public showMessageType: boolean = false;
  public parentMessageTemplates: any = [];

  constructor(
    private serviceTypeService: ServiceTypeService,
    private partnerService: PartnerService,
    public appConfig: AppConfig,
  ) {}

  ngOnInit() {
    this.getServiceTypeMessageTemplates();
    this.getParentMessageTemplates();
  }

  getParentMessageTemplates() {
    this.partnerService
      .getMessageTemplates(this.partner.ID)
      .subscribe((templates) => {
        this.parentMessageTemplates = templates;
      });
  }

  getServiceTypeMessageTemplates() {
    this.loading = true;
    this.serviceTypeService
      .getServiceTypeMessageTemplates(this.partner.ID, this.serviceType.ID)
      .subscribe(
        (templates) => {
          templates.forEach((template) => {
            var order =
              this.appConfig.getMessageTemplateOrder()[template.eventTag];
            if (order) {
              template.order = order;
            } else {
              template.order = 100;
            }
          });

          // this.messageTemplates = templates.map(item => { return { label: item.EventTag.toUpperCase(), value: item.ID } });
          this.messageTemplates = templates.sort((a, b) => {
            if (a.order < b.order) {
              return -1;
            } else if (a.order > b.order) {
              return 1;
            } else {
              return 0;
            }
          });
          console.log(this.messageTemplates);
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  selectMessageType(item) {
    this.selectedMessageTemplate = item;
    this.showMessageType = true;
  }

  closePanel(event) {
    this.showMessageType = false;
    this.getServiceTypeMessageTemplates();
  }
}
